import { useRef, useEffect } from "react";
import { strip } from ".";

export const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const useGtmProvider = me => {
  useEffect(() => {
    if (!me || typeof window === "undefined") return;
    const userId = me?.id || "";
    const userEmail = strip(me?.email || "");
    const userFirstname = strip(me?.name || "");
    const service = "admin";
    const gitBranch = "";
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      userId,
      userEmail,
      userFirstname,
      service,
      gitBranch
    });
  }, [me]);

  return null;
};
